<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8" body-class="p-0">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Listado de usuarios chatbot</p>
        </template>
        <b-table 
            responsive
            :fields="fields" 
            striped hover 
            :items="users"
            class="mb-0">
                <template v-slot:cell(company_name)="data">
                    {{ data.item.empresa.nombre }}
                </template>
                <template v-slot:cell(nombre)="data">
                    {{ data.item.nombre }}
                </template>
                
                <template v-slot:cell(email)="data">
                    {{ data.item.email }}
                </template>
                <template v-slot:cell(telefono)="data">
                    {{ data.item.telefono }}
                </template>
               <template v-slot:cell(status)="data">
                    <b-badge :variant="statusVariant(data.item.status)">
                        {{ statusLabel(data.item.status) }}
                    </b-badge>
                </template>
                <template v-slot:cell(actions)="{ item }">
                    <b-button 
                        variant="info" 
                        size="sm"
                        class="mr-1"
                        v-b-tooltip.hover title="Reenviar Contraseña"
                        :disabled="item.status === 0"
                        @click.prevent="sendPasswordReset(item)"
                    >
                        <b-icon icon="envelope" />
                    </b-button>
                </template>
            </b-table>
            <template v-if="users.length < 1">
                <b-alert show variant="danger">
                    Lo sentimos, no se han encontrado resultados para su busqueda.
                </b-alert>
            </template>
        
        <template v-slot:footer>
            <b-row class="tipo-vistas-card justify-content-md-center">
                <b-col cols="12" sm="1">
                    <b-form-select @change="updatePageSize()" v-model="paginator.pageSize" :options="pageSize" ></b-form-select>
                </b-col>                    
                <b-col cols="12" md="4">
                    <b-pagination 
                        size="md" 
                        pills 
                        :total-rows="paginator.totalPage" 
                        v-model="paginator.page" 
                        :per-page="1" 
                        @input="changePage" 
                        first-number 
                        last-number>
                    </b-pagination>
                </b-col>
            </b-row>
        </template>
    </b-card>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
    name: "UsersTable",
    props: {
        users: {
            type: Array
        },
        paginator: {
            type: Object
        },
        pageSize: {
            type: Array
        }
    },
    data(){
        return{
            fields: [
                { key: 'nit', label: 'NIT', sortable: true},
                { key: 'company_name', label: 'Empresa', sortable: true},    
                { key: 'name', label: 'Nombre', sortable: true},
                { key: 'email', label: 'Correo electronico', sortable: true},
                { key: 'status', label: 'Estado', sortable: true},
                { key: 'actions', label: 'Acciones'},
            ],
        }
    },
    methods: {
        ...mapMutations(['setLoading']),
        updatePageSize(){
            /* the page sizee return the current page to initial because we can't know if the current page have items asigned!! */
            this.paginator.page = 1;
            /* emit the page size update to get the new list of items*/
            this.$emit('get-users-list');
        },
        changePage(){
            this.$emit('change-page', this.paginator.page);
        },
        async sendPasswordReset(item) {
            const confirmed = await this.$bvModal.msgBoxConfirm(
                this.$createElement('div', [
                    this.$createElement('p', '¿Está seguro que desea enviar el correo de restablecimiento de contraseña a:'),
                    this.$createElement('strong', item.name),
                    this.$createElement('br'),
                    this.$createElement('strong', item.email),
                ]),
                {
                    title:       'Confirmar restablecimiento',
                    okVariant:   'primary',
                    okTitle:     'Sí, enviar',
                    cancelTitle: 'No',
                    centered:    true,
                }
            );

            if (!confirmed) return;

            this.setLoading(true);

            await this.$conectar.post(`/admin/chatbot-users/${item.id}/send-password-reset`)
            .then(response => {
                if (response.data.error == true) {
                    this.$root.$bvToast.toast(response.data.message, {
                        title:   'Respuesta del servidor',
                        variant: 'danger',
                        solid:   true
                    });
                } else {
                    this.$root.$bvToast.toast(response.data.message, {
                        title:   'Respuesta del servidor',
                        variant: 'success',
                        solid:   true
                    });
                }
            })
            .catch(() => {
                this.$root.$bvToast.toast('Error en el servidor, favor intente nuevamente más tarde', {
                    title:   'Respuesta del servidor',
                    variant: 'danger',
                    solid:   true
                });
            });

            this.setLoading(false);
        },

        statusVariant(status) {
            return status === 1 ? 'success' : 'danger';
        },
        statusLabel(status) {
            return status === 1 ? 'Activo' : 'Inactivo';
        }
    }
};

</script>
<style scoped>

</style>